/* global axios */
import ApiClient from './ApiClient';

class CrmAPI extends ApiClient {
  constructor() {
    super('crm', { accountScoped: true });
  }

  getFunnels() {
    return axios.get(`${this.url}/funnels`);
  }

  createFunnel(data) {
    return axios.post(`${this.url}/funnels`, { funnel: data });
  }

  updateFunnel(funnelId, data) {
    return axios.patch(`${this.url}/funnels/${funnelId}`, { funnel: data });
  }

  getStages(funnelId) {
    return axios.get(`${this.url}/funnels/${funnelId}/stages`);
  }

  createStage(funnelId, data) {
    return axios.post(`${this.url}/funnels/${funnelId}/stages`, {
      funnel_stage: data,
    });
  }

  updateStage(funnelId, stageId, data) {
    return axios.patch(`${this.url}/funnels/${funnelId}/stages/${stageId}`, {
      funnel_stage: data,
    });
  }

  deleteStage(funnelId, stageId) {
    return axios.delete(`${this.url}/funnels/${funnelId}/stages/${stageId}`);
  }

  reorderStages(funnelId, stageIds) {
    return axios.post(`${this.url}/funnels/${funnelId}/stages/reorder`, {
      stage_ids: stageIds,
    });
  }

  getFunnelAgents(funnelId) {
    return axios.get(`${this.url}/funnels/${funnelId}/agents`);
  }

  addFunnelAgent(funnelId, userId) {
    return axios.post(`${this.url}/funnels/${funnelId}/agents`, {
      user_id: userId,
    });
  }

  removeFunnelAgent(funnelId, userId) {
    return axios.delete(`${this.url}/funnels/${funnelId}/agents/${userId}`);
  }

  getOpportunities(params = {}) {
    return axios.get(`${this.url}/opportunities`, { params });
  }

  getOpportunity(id) {
    return axios.get(`${this.url}/opportunities/${id}`);
  }

  createOpportunity(data) {
    return axios.post(`${this.url}/opportunities`, { opportunity: data });
  }

  updateOpportunity(id, data) {
    return axios.patch(`${this.url}/opportunities/${id}`, {
      opportunity: data,
    });
  }

  deleteOpportunity(id) {
    return axios.delete(`${this.url}/opportunities/${id}`);
  }

  moveOpportunityStage(id, stageId) {
    return axios.post(`${this.url}/opportunities/${id}/stage`, {
      funnel_stage_id: stageId,
    });
  }

  getContactOpportunities(contactId) {
    return axios.get(
      `${this.baseUrl()}/contacts/${contactId}/crm_opportunities`
    );
  }

  getOrigins() {
    return axios.get(`${this.url}/origins`);
  }

  createOrigin(data) {
    return axios.post(`${this.url}/origins`, { crm_origin: data });
  }

  updateOrigin(id, data) {
    return axios.patch(`${this.url}/origins/${id}`, { crm_origin: data });
  }

  deleteOrigin(id) {
    return axios.delete(`${this.url}/origins/${id}`);
  }
}

export default new CrmAPI();
